var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    { 'icon-star-golden': this.star },
    { 'icon-star': this.star === 'false' } ],attrs:{"data-cy":"infoset-icon-star-cell"},on:{"click":_vm.sendToggleStar}})}
var staticRenderFns = []

export { render, staticRenderFns }